const comensais = document.querySelector("#comensais");
const qtde_principal = document.querySelector("#qtde_principal");
const qtde_opcao_1 = document.querySelector("#qtde_opcao_1");
const qtde_omelete_frios = document.querySelector("#qtde_omelete_frios");
const qtde_omelete_queijo = document.querySelector("#qtde_omelete_queijo");
const qtde_omelete_especial = document.querySelector("#qtde_omelete_especial");
const qtde_file_frango = document.querySelector("#qtde_file_frango");
const qtde_prato_light = document.querySelector("#qtde_prato_light");
const qtde_veget = document.querySelector("#qtde_veget");
const qtde_ovo_frito = document.querySelector("#qtde_ovo_frito");
const qtde_ovo_cozido = document.querySelector("#qtde_ovo_cozido");
const qtde_sopa = document.querySelector("#qtde_sopa");
const qtde_dm = document.querySelector("#qtde_dm");
const qtde_prato_cheff = document.querySelector("#qtde_prato_cheff");
const qtde_prato_gourmet = document.querySelector("#qtde_prato_gourmet");

if (comensais) {
  comensais.addEventListener("change", (e) => {
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      comensais.value = e.target.value;
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = comensais.value;
    } else {
      comensais.value = e.target.value;
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = "";
    }
    qtde_omelete_frios.value = "";
    qtde_omelete_queijo.value = "";
    qtde_omelete_especial.value = "";
    qtde_file_frango.value = "";
    qtde_prato_light.value = "";
    qtde_veget.value = "";
    qtde_ovo_frito.value = "";
    qtde_ovo_cozido.value = "";
    if (qtde_sopa) {
      qtde_sopa.value = "";
    }
    if (qtde_dm) {
      qtde_dm.value = "";
    }
    if (qtde_prato_cheff) {
      qtde_prato_cheff.value = "";
    }
    if (qtde_prato_gourmet) {
      qtde_prato_gourmet.value = "";
    }
  });
}

if (qtde_opcao_1) {
  qtde_opcao_1.addEventListener("change", (e) => {
    qtde_opcao_1.value = e.target.value;
    qtde_principal.value = refazerConta();
  });
}

if (qtde_omelete_frios) {
  qtde_omelete_frios.addEventListener("change", (e) => {
    qtde_omelete_frios.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_omelete_queijo) {
  qtde_omelete_queijo.addEventListener("change", (e) => {
    qtde_omelete_queijo.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_omelete_especial) {
  qtde_omelete_especial.addEventListener("change", (e) => {
    qtde_omelete_especial.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_file_frango) {
  qtde_file_frango.addEventListener("change", (e) => {
    qtde_file_frango.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_prato_light) {
  qtde_prato_light.addEventListener("change", (e) => {
    qtde_prato_light.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_veget) {
  qtde_veget.addEventListener("change", (e) => {
    qtde_veget.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_ovo_frito) {
  qtde_ovo_frito.addEventListener("change", (e) => {
    qtde_ovo_frito.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_ovo_cozido) {
  qtde_ovo_cozido.addEventListener("change", (e) => {
    qtde_ovo_cozido.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_dm) {
  qtde_dm.addEventListener("change", (e) => {
    qtde_dm.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_sopa) {
  qtde_sopa.addEventListener("change", (e) => {
    qtde_sopa.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

if (qtde_prato_cheff) {
  qtde_prato_cheff.addEventListener("change", (e) => {
    qtde_prato_cheff.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}
if (qtde_prato_gourmet) {
  qtde_prato_gourmet.addEventListener("change", (e) => {
    qtde_prato_gourmet.value = e.target.value;
    if (
      cliente.value == 5 ||
      cliente.value == 10 ||
      cliente.value == 12 ||
      cliente.value == 15 ||
      cliente.value == 16 ||
      cliente.value == 20 ||
      cliente.value == 17 ||
      cliente.value == 18 ||
      cliente.value == 19 ||
      cliente.value == 21 ||
      cliente.value == 22 ||
      cliente.value == 23 ||
      cliente.value == 24 ||
      cliente.value == 31 ||
      cliente.value == 43 ||
      cliente.value == 33 ||
      cliente.value == 72 ||
      cliente.value == 90 ||
      cliente.value == 54 ||
      cliente.value == 55 ||
      cliente.value == 73 ||
      cliente.value == 91 ||
      cliente.value == 113 ||
      cliente.value == 119 ||
      cliente.value == 120 ||
      cliente.value == 121 ||
      cliente.value == 123
    ) {
      qtde_principal.value = comensais.value;
      qtde_opcao_1.value = refazerContaMeio();
    } else {
      qtde_principal.value = refazerConta();
    }
  });
}

function refazerConta() {
  negativos = 0;

  if (qtde_opcao_1 && qtde_opcao_1.value) {
    negativos += parseInt(qtde_opcao_1.value);
  }
  if (qtde_omelete_frios && qtde_omelete_frios.value) {
    negativos += parseInt(qtde_omelete_frios.value);
  }
  if (qtde_omelete_queijo && qtde_omelete_queijo.value) {
    negativos += parseInt(qtde_omelete_queijo.value);
  }
  if (qtde_omelete_especial && qtde_omelete_especial.value) {
    negativos += parseInt(qtde_omelete_especial.value);
  }
  if (qtde_file_frango && qtde_file_frango.value) {
    negativos += parseInt(qtde_file_frango.value);
  }
  if (qtde_prato_light && qtde_prato_light.value) {
    negativos += parseInt(qtde_prato_light.value);
  }
  if (qtde_veget && qtde_veget.value) {
    negativos += parseInt(qtde_veget.value);
  }
  if (qtde_ovo_frito && qtde_ovo_frito.value) {
    negativos += parseInt(qtde_ovo_frito.value);
  }
  if (qtde_ovo_cozido && qtde_ovo_cozido.value) {
    negativos += parseInt(qtde_ovo_cozido.value);
  }
  if (qtde_dm && qtde_dm.value) {
    negativos += parseInt(qtde_dm.value);
  }
  if (qtde_sopa && qtde_sopa.value) {
    negativos += parseInt(qtde_sopa.value);
  }
  if (qtde_prato_cheff && qtde_prato_cheff.value) {
    negativos += parseInt(qtde_prato_cheff.value);
  }
  if (qtde_prato_gourmet && qtde_prato_gourmet.value) {
    negativos += parseInt(qtde_prato_gourmet.value);
  }

  return comensais.value - negativos;
}

function refazerContaMeio() {
  negativos = 0;

  if (qtde_omelete_frios && qtde_omelete_frios.value) {
    negativos += parseInt(qtde_omelete_frios.value);
  }
  if (qtde_omelete_queijo && qtde_omelete_queijo.value) {
    negativos += parseInt(qtde_omelete_queijo.value);
  }
  if (qtde_omelete_especial && qtde_omelete_especial.value) {
    negativos += parseInt(qtde_omelete_especial.value);
  }
  if (qtde_file_frango && qtde_file_frango.value) {
    negativos += parseInt(qtde_file_frango.value);
  }
  if (qtde_prato_light && qtde_prato_light.value) {
    negativos += parseInt(qtde_prato_light.value);
  }
  if (qtde_veget && qtde_veget.value) {
    negativos += parseInt(qtde_veget.value);
  }
  if (qtde_ovo_frito && qtde_ovo_frito.value) {
    negativos += parseInt(qtde_ovo_frito.value);
  }
  if (qtde_ovo_cozido && qtde_ovo_cozido.value) {
    negativos += parseInt(qtde_ovo_cozido.value);
  }
  if (qtde_dm && qtde_dm.value) {
    negativos += parseInt(qtde_dm.value);
  }
  if (qtde_sopa && qtde_sopa.value) {
    negativos += parseInt(qtde_sopa.value);
  }
  if (qtde_prato_cheff && qtde_prato_cheff.value) {
    negativos += parseInt(qtde_prato_cheff.value);
  }
  if (qtde_prato_gourmet && qtde_prato_gourmet.value) {
    negativos += parseInt(qtde_prato_gourmet.value);
  }

  return comensais.value - negativos;
}
